import React from 'react'
import LiveTryOn from './livetryon'
import {BsFillCameraVideoFill} from 'react-icons/bs'
import Model from './models'
export default class HomePage extends React.Component{
	constructor(props){
		super(props)
		this.state={
			show:'none'
		}
		this.show=this.show.bind(this)
		this.closeLive=this.closeLive.bind(this)
		this.closeModel=this.closeModel.bind(this)
	}
	show(val){
		this.setState({
			show:val
		})
	}
	closeLive(val){
		this.setState({
			show:'none'
		})
	}
	closeModel(val){
		this.setState({
			show:'none'
		})
	}
	render(){
		return(
			<div>
				{this.state.show === 'none' ?  
				<div className="main-container">
					<div className="secondary-container">	
						<p className="heading">LipStick Try-On</p>
						<p className="text-center">Meeting your next favourite lip colour online is now easier.</p>
						<div className="button-container">
							<button className="t-btn" onClick={()=>this.show('Live')}><BsFillCameraVideoFill/> Try on your Face!!</button>
							<br/>
							<hr className="hr"/>
							<button className="m-btn" onClick={()=>this.show('Model')}>Try on a Model</button>
						</div>
					</div>
				</div>
				:
				(this.state.show === 'Live' ? <LiveTryOn close={this.closeLive}/> : <Model close={this.closeModel}/>)
			}
			</div>
			)
	}
}